import { mapKeys } from 'lodash';

export default class RansackQuery {

  constructor(queryValues, keys) {
    this.queryValues = queryValues;
    this.keys = keys;
  }

  toRansack() {
    return mapKeys(this.queryValues, (_value, key) => this.keys[key] || key);
  }
}
